import './i18n'
import './index.css'

import ReactDOM from 'react-dom/client'

import App from './App.jsx'
import { MyThemeProvider as ThemeProvider } from './components/Layout/ThemeProvider/ThemeProvider.jsx'
import { AuthProvider } from './components/Shared/Contexts/AuthContext'
import { GlobalContextProvider } from './components/Shared/Contexts/GlobalContext'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <AuthProvider>
    <GlobalContextProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </GlobalContextProvider>
  </AuthProvider>
)
